"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ShoppingTagLined = function ShoppingTagLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.854 7.153a2.735 2.735 0 01-.645-1.52 4.781 4.781 0 00-1.228-2.592A3.384 3.384 0 0017.553 2h-.033a3.55 3.55 0 00-2.495 1.034 3.653 3.653 0 00-1.006 1.974h-2.46a.749.749 0 00-.532.219l-8.806 8.8a.752.752 0 000 1.064l6.691 6.688a.754.754 0 001.062 0l8.8-8.8a.754.754 0 00.226-.533V7.624a.752.752 0 00-.22-.531l-1.866-1.866a.748.748 0 00-.531-.219h-1.354a2.646 2.646 0 01.7-1.267A2.512 2.512 0 0117.543 3a2.392 2.392 0 011.718.734 3.789 3.789 0 01.97 2.105 3.634 3.634 0 00.915 2.021.5.5 0 00.708-.707zM18 7.727v4.616L9.441 20.9 3.1 14.562l8.558-8.555h2.31a4.056 4.056 0 00.334 1.285 1.007 1.007 0 101-.224 3.081 3.081 0 01-.332-1.061h1.31z",
    fill: "currentColor"
  })));
};

var _default = ShoppingTagLined;
exports["default"] = _default;